// Autobahn (auto.de redesign) — Meine Bestellung (/account/my-orders), ADV-264.
//
// Figma "KONTO | 02 Bestellung" (desktop 1280 / mobile 390): breadcrumb back to the dashboard,
// one card per order (OrderCard: Bestellstatus, vehicle, addresses, costs) and the customer
// service card. The orders and all their data are Odoo's leads in progress
// (odoo-sync leads?wonStatus=pending). Page-local styles: ./MyOrdersNextPage.css.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icon } from '@bytebrand/fe-ui-core-autobahn/ui';
import ProfileAPI from '../../../services/ProfileAPI';
import Page from '../../containers/Page';
import OrderCard from './OrderCard';
import OrderDetailsModal from './OrderDetailsModal';
import WithdrawalModal from './WithdrawalModal';
import { hasCar, sellerIdOf, sellerOf } from './orderData';
import chevronIcon from './icons/breadcrumb-chevron.svg';
import serviceIcon from './icons/service-question.svg';
import './MyOrdersNextPage.css';
const ns = (key) => `MyOrderPage:orders.${key}`;
// Figma "mcard — Kundenservice".
const ServiceCard = ({ t }) => (React.createElement("section", { className: "ao-service" },
    React.createElement("span", { className: "ao-service-ic" },
        React.createElement("img", { src: serviceIcon, alt: "", width: 26, height: 26 })),
    React.createElement("h2", { className: "ao-service-title" }, t(ns('serviceTitle'))),
    React.createElement("p", { className: "ao-service-text" }, t(ns('serviceText'))),
    React.createElement("div", { className: "ao-service-action" },
        React.createElement(Link, { className: "ao-service-btn", to: "/account/kontakt" }, t(ns('serviceButton'))))));
let MyOrdersNextPage = class MyOrdersNextPage extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { details: null, withdrawal: null, sellers: {}, loaded: false }
        });
        Object.defineProperty(this, "orders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.props.profileStore.orderedCars || []).filter(hasCar)
        });
        // The Widerruf recipient is the car's seller: the same dealer info the checkout loads, once
        // per owner. Called on ProfileAPI directly — profileStore's wrapper flips the page's isFetching.
        Object.defineProperty(this, "loadSellers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const ids = Array.from(new Set(this.orders().map(sellerIdOf).filter(Boolean)));
                ids.forEach((id) => {
                    ProfileAPI.getDealerProfileCheckout(id)
                        .then(sellerOf, () => null)
                        .then((seller) => this.setState(({ sellers }) => ({ sellers: { ...sellers, [id]: seller } })));
                });
            }
        });
        Object.defineProperty(this, "sellerFor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lead) => this.state.sellers[sellerIdOf(lead)] || null
        });
        Object.defineProperty(this, "showDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lead, kind) => this.setState({ details: { lead, kind } })
        });
        Object.defineProperty(this, "hideDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setState({ details: null })
        });
        Object.defineProperty(this, "showWithdrawal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lead) => this.setState({ withdrawal: lead })
        });
        Object.defineProperty(this, "hideWithdrawal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setState({ withdrawal: null })
        });
        Object.defineProperty(this, "withdrawalSent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.hideWithdrawal();
                this.props.notificationStore.addNotification({ message: this.props.t('MyOrderPage:orders.wd.sent'), level: 'success' });
            }
        });
        Object.defineProperty(this, "showError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.props.notificationStore.addNotification({ message: this.props.t('Notifications:errors.default'), level: 'error' })
        });
    }
    componentDidMount() {
        Promise.resolve(this.props.profileStore.getPendingRequestedCars()).then(() => {
            this.setState({ loaded: true }, this.loadSellers);
        });
    }
    render() {
        const { t, imagesStore, authStore, profileStore: { isFetching } } = this.props;
        const { details, withdrawal } = this.state;
        const orders = this.orders();
        let content;
        if (!this.state.loaded || isFetching) {
            content = React.createElement("div", { className: "mv-loading" },
                React.createElement("span", { className: "auth-spinner" }));
        }
        else if (orders.length) {
            content = (React.createElement("div", { className: "ao-list" },
                orders.map((lead) => (React.createElement(OrderCard, { key: lead._id || lead.request, lead: lead, contract: null, t: t, imagesStore: imagesStore, onShowDetails: this.showDetails, onContractError: this.showError, seller: this.sellerFor(lead), onWithdraw: this.showWithdrawal }))),
                React.createElement(ServiceCard, { t: t })));
        }
        else {
            content = React.createElement("div", { className: "ms-empty" },
                React.createElement(Icon, { name: "package", size: 40 }),
                React.createElement("h3", null, t(ns('empty'))));
        }
        return (React.createElement(Page, { page: "MY_ORDER", mainContentClass: "ao-main" },
            React.createElement("div", { className: "md3" },
                React.createElement("div", { className: "ao-page" },
                    React.createElement("nav", { className: "ao-crumbs", "aria-label": t(ns('breadcrumbLabel')) },
                        React.createElement(Link, { className: "ao-crumb-link", to: "/account/dashboard" }, t(ns('dashboard'))),
                        React.createElement("img", { className: "ao-crumb-sep", src: chevronIcon, alt: "", width: 14, height: 14 }),
                        React.createElement("h1", { className: "ao-crumb-current", "aria-current": "page" }, t(ns('title')))),
                    content),
                details ? (React.createElement(OrderDetailsModal, { lead: details.lead, kind: details.kind, contract: null, t: t, onClose: this.hideDetails })) : null,
                withdrawal ? (React.createElement(WithdrawalModal, { lead: withdrawal, seller: this.sellerFor(withdrawal), email: authStore.userEmail || '', t: t, onClose: this.hideWithdrawal, onSent: this.withdrawalSent, onError: this.showError })) : null)));
    }
};
MyOrdersNextPage = __decorate([
    inject('authStore', 'profileStore', 'imagesStore', 'notificationStore'),
    observer
], MyOrdersNextPage);
export default translate(['DealerDashboardPage', 'MyOrderPage', 'autobahn'])(MyOrdersNextPage);
